import { render, staticRenderFns } from "./SavePageButton.vue?vue&type=template&id=4b351fcc&scoped=true&"
import script from "./SavePageButton.vue?vue&type=script&lang=js&"
export * from "./SavePageButton.vue?vue&type=script&lang=js&"
import style0 from "./SavePageButton.vue?vue&type=style&index=0&id=4b351fcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b351fcc",
  null
  
)

export default component.exports